import { time } from '@lm/constants'

import {
  AVAILABILITY_REFETCH_EVERY_SECONDS,
  SCREENSAVER_TIMEOUT_SECONDS,
} from './configurations'

// AUTH
export const AUTH_USER_KEY = 'ekiosk-user'

export const LAVOMAT_EMAIL_DOMAIN = '@lavomat.com.uy'

export const LAVOMAT_EMAIL_PATTERN = /.+@lavomat\.com\.uy$/i

// ORDER
/**
 * The time in milliseconds to reset the order result.
 * Default: 30 seconds
 */
export const ORDER_RESULT_AUTO_RESET_MS = 30_000 // 30 seconds

/**
 * Timeout before screensaver, in milliseconds.
 * Default: 40 seconds
 */
export const SCREENSAVER_TIMEOUT_MS = (() => {
  const defaultValue = 40 * time.ONE_SECOND
  const config = SCREENSAVER_TIMEOUT_SECONDS

  if (!config) return defaultValue

  const seconds = Number(config)
  if (Number.isNaN(seconds) || seconds <= 0) return defaultValue

  return seconds * time.ONE_SECOND
})()

// Availability data
/**
 * The time in seconds to refetch the availability data.
 */
export const AVAILABILITY_DATA_REFETCH_EVERY_SECONDS: number | boolean =
  (() => {
    const config = AVAILABILITY_REFETCH_EVERY_SECONDS
    const defaultValue = 60 * 2 // 2 minutes

    if (!config) return defaultValue

    const normalized = config.toLowerCase()
    if (normalized === 'false') return false

    const seconds = Number(config)
    if (Number.isNaN(seconds)) return defaultValue

    return seconds
  })()
